import React from "react";
import PropTypes from "prop-types";
import CompanyImage from "../common/company_image";
import Experience from "./experience";

function Career(props) {
  const { career } = props;
  const company = career.company;

  return (
    <React.Fragment>
      <td className='company-logo'>
        <span>
          <CompanyImage company={company} {...props} />
        </span>
      </td>
      <td className='company-info'>
        <h5 className='company-name'>{company.name}</h5>
        {career.experiences.map(experience  => {
          return (
            <Experience key={experience.id} experience={experience} />
          );
        })}
      </td>
    </React.Fragment>
  );
}

Career.propTypes = {
  career: PropTypes.shape({
    id: PropTypes.number.isRequired,
    company: PropTypes.object.isRequired,
    experiences: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired
};

export default Career;
